export default {
  ENDPFOSTEN: 1358,
  ECKPFOSTEN: 1404,
  MITTELPFOSTEN: 1360,
  BARRIERE: 2222,
  BARRIERE_1500: 2223,
}